import {useEffect} from 'react'
import Footer from "../components/Footer";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Rightbar from "../components/Rightbar";
import Pagetitle from "../components/Pagetitle";
import Loader from "../components/Loader";

const MainLayout = ({ children }) => {
  useEffect(() => {
    const event = new Event("rendered");
    document.dispatchEvent(event);
  }, []);
  
return (
  <>
  <div id="layout-wrapper">
    <Loader/>
    <Header/>
      <Sidebar/>
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              <Pagetitle/>
                {children}
            </div>
          </div>
          <Footer/>
        </div>
    </div>
    <Rightbar/>
  </>
  );
}
  
  export default MainLayout;
  